var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTargetFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.054 6.106c3.27 0 5.937 2.66 5.937 5.937a5.94 5.94 0 0 1-5.937 5.937 5.94 5.94 0 0 1-5.937-5.937 5.94 5.94 0 0 1 5.937-5.937Zm0 8.916a2.978 2.978 0 1 0 0-5.957 2.978 2.978 0 0 0 0 5.957Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.06 24.01c6.628 0 12-5.373 12-12s-5.372-12-12-12c-6.627 0-12 5.373-12 12s5.373 12 12 12Zm-.006-19.456a7.49 7.49 0 0 0-7.49 7.49c0 4.139 3.35 7.488 7.49 7.488 4.14 0 7.49-3.35 7.49-7.489 0-4.14-3.35-7.489-7.49-7.489Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTargetFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TargetFilled.022d96272c17dbe6b1007d1be2e0a664.svg";